<script lang="ts">
  import { cn } from "@tastyworks/ui-library"
  import type { Snippet } from "svelte"
  import { actionsVariants } from "."

  type Props = {
    alignActions?: "start" | "center" | "end"
    variant?: "horizontal" | "vertical"
    class?: string
    children?: Snippet
    [key: string]: unknown
  }

  let {
    alignActions = "end",
    variant = "horizontal",
    class: className,
    children,
    ...restProps
  }: Props = $props()

  // Ghost and link actions render unpadded; in a footer they size like a large
  // primary, even when wrapped (tooltip, form).
  const unpaddedActions =
    "[&_:is([data-variant^=ghost],[data-variant=link],a)]:border [&_:is([data-variant^=ghost],[data-variant=link],a)]:border-transparent [&_:is([data-variant^=ghost],[data-variant=link],a)]:px-4 [&_:is([data-variant^=ghost],[data-variant=link],a)]:py-2"
</script>

<div
  class={cn(actionsVariants({ variant }), unpaddedActions, className)}
  class:justify-start={alignActions === "start"}
  class:justify-center={alignActions === "center"}
  class:justify-end={alignActions === "end"}
  {...restProps}
>
  {@render children?.()}
</div>
